import { Box } from '@mui/material'
import CardWithSpace from '../Cards/CardWithSpace/index.jsx'

const FilterByForm = ({
  formStatus,
  children,
  customStyles = {},
}) => (
  <Box >
    {formStatus && (
    <CardWithSpace flex customStyles={{ ...styles.cardStyle, ...customStyles }}>
      {children}
    </CardWithSpace>
    )}
  </Box>
)

const styles = {
  cardStyle: {
    padding: '20px 40px',
    marginTop: { xs: '0px', sm: '40px' },
  },
}

export default FilterByForm
